import { useReducer } from 'react';

const initialState = { translateX: 0, translateY: 0, prevMouseX: 0, prevMouseY: 0 };

const reducer = (currentPosition, action) => {
  switch (action.type) {
    case 'beginDrag':
      return { ...currentPosition, prevMouseX: action.clientX, prevMouseY: action.clientY };
    case 'executeDrag':
      const deltaMouseX = action.clientX - currentPosition.prevMouseX;
      const deltaMouseY = action.clientY - currentPosition.prevMouseY;
      return {
        ...currentPosition,
        translateX: currentPosition.translateX + deltaMouseX,
        translateY: currentPosition.translateY + deltaMouseY,
        prevMouseX: action.clientX,
        prevMouseY: action.clientY,
      };
    default:
      return currentPosition;
  }
};

const useImageDrag = () => {
  const [currentPosition, moveImage] = useReducer(reducer, initialState);

  const onMouseMove = (event) => {
    event.preventDefault();
    moveImage({ type: 'executeDrag', clientX: event.clientX, clientY: event.clientY });
  };
  const onMouseUp = () => {
    window.removeEventListener('mouseup', onMouseUp);
    window.removeEventListener('mousemove', onMouseMove);
  };

  const beginDrag = (event) => {
    moveImage({ type: 'beginDrag', clientX: event.clientX, clientY: event.clientY });
    window.addEventListener('mouseup', onMouseUp);
    window.addEventListener('mousemove', onMouseMove);
  };

  return { ...currentPosition, beginDrag };
};

export default useImageDrag;
